import { render } from "./AtaCard.vue?vue&type=template&id=a45e2e56&scoped=true"
const script = {}

import "./AtaCard.vue?vue&type=style&index=0&id=a45e2e56&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a45e2e56"]])

export default __exports__